import { getRuntimeEnv } from "./runtimeConfig";

export const DEFAULT_TENANT = "ooru";

const TENANT_CONFIGS = {
  ooru: {
    id: "ooru",
    appName: "CredIssuer",
    preferredLocale: undefined,
    localeOverrides: {},
    otelServiceName: "credflow-web-frontend",
    showLandingPage: true,
  },
  stp: {
    id: "stp",
    appName: "CredIssuer",
    preferredLocale: "pt",
    localeOverrides: {},
    otelServiceName: "issuer-portal-frontend",
    showLandingPage: false,
  },
};

const normalise = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

export const resolveEnvPreferredLocale = (
  value = getRuntimeEnv("REACT_APP_DEFAULT_LANGUAGE"),
) => {
  const locale = normalise(value);
  return locale || undefined;
};

export const resolveTenant = (value) => {
  const id = normalise(value);
  return Object.prototype.hasOwnProperty.call(TENANT_CONFIGS, id)
    ? id
    : DEFAULT_TENANT;
};

export const getTenantConfig = (value) => {
  const base = TENANT_CONFIGS[resolveTenant(value)];
  const fromEnv = resolveEnvPreferredLocale();
  return {
    ...base,
    preferredLocale: fromEnv ?? base.preferredLocale,
  };
};

export const isKnownTenant = (value) =>
  Object.prototype.hasOwnProperty.call(TENANT_CONFIGS, normalise(value));

export const currentTenant = resolveTenant(getRuntimeEnv("REACT_APP_TENANT"));

export const appConfig = getTenantConfig(getRuntimeEnv("REACT_APP_TENANT"));

export default appConfig;
